import { startsWithInvariantCase } from './string';

export interface GitHubInfo {
  repo: string;
  repoSlug: string;
  repoUrl: string;
  path: string;
}

export const getGitHubInfo = (url: string): GitHubInfo | null => {
  if (!startsWithInvariantCase(url, 'https://github.com/')) {
    return null;
  }
  const text = url.substring(`https://github.com/`.length);
  const repoPatternMatches = text.match(/^(.+?\/(.+?))(\/|$)/);
  if (repoPatternMatches === null) {
    return null;
  }
  const repoSlug = `${repoPatternMatches[1]}`;
  const repo = repoPatternMatches[2];
  const path = text
    .substring(repoSlug.length)
    .replace(/^\/(tree|blob)\/.+?\//, '');
  return {
    repo,
    repoSlug,
    repoUrl: `https://github.com/${repoSlug}`,
    path,
  };
};
